<div class="tpp-process-box" [ngClass]="{ 'fixed-tpp-process-box': fixedContainer }" fxLayout="row" fxLayoutGap="25px">
	<div
		class="filters-container"
		[formGroup]="form"
		fxFlex="70"
		fxLayoutAlign="start"
		fxLayout="row"
		fxLayoutGap="24px"
	>
		<button (click)="refreshPayouts()" id="btnRefresh" class="refresh-button" mat-icon-button>
			<app-icon
				class="refresh-payouts-icon"
				[name]="'rotate-right'"
				[color]="'var(--color-text-default)'"
				[lineWidth]="'1.5px'"
				[size]="'28'"
			></app-icon>
		</button>
		<input-wrapper class="custom-wrapper" fxFlex="30">
			<input-select
				id="inpCancelledRuns"
				formControlName="selectedRun"
				[options]="runSelection"
				[value]="runSelection[0].value"
				class="select-input"
			>
			</input-select>
		</input-wrapper>
		<input-wrapper class="custom-wrapper">
			<app-multi-layer-status-filter
				[attr.data-test]="'tpp-status-filter'"
				formControlName="transactionStatuses"
				label="Statuses and bulk actions"
				[transactionOptions]="transactionOptions"
				(filterStatusSelectionChange)="filterStatusSelectionChange($event)"
				(bulkActionSelected)="setBulkActionSelected($event)"
				class="select-input"
			>
			</app-multi-layer-status-filter>
		</input-wrapper>
	</div>

	@if (!isBulkSelected) {
	<div
		class="button-container flex flex-align-stretch-end"
		*ngIf="buttonState === 'process' || buttonState === 'inactive'"
	>
		<ng-template
			[appUserRolePermissions]
			[action]="'hide'"
			[roles]="['TS_IMPLEMENTATION_LEAD', 'TS_OPERATION_CONSULTANT', 'TS_VO', 'CLIENT']"
		>
			<button
				mat-raised-button
				disabled="{{ buttonState === 'inactive' }}"
				*ngIf="canProcessBooking"
				class="process-button"
				(click)="openDialog('book the payments')"
				id="btnProcess"
			>
				<span>Process Booking</span>
			</button>
		</ng-template>
	</div>

	<div class="button-container flex flex-align-stretch-end" *ngIf="buttonState === 'reprocess'">
		<ng-template
			[appUserRolePermissions]
			[action]="'hide'"
			[roles]="[
				'TS_IMPLEMENTATION_LEAD',
				'TS_IMPLEMENTATION_CONSULTANT',
				'TS_OPERATION_CONSULTANT',
				'TS_OCB',
				'TS_VO',
				'CLIENT'
			]"
		>
			<button
				mat-raised-button
				class="process-button"
				[disabled]="payoutIdList.length < 1"
				(click)="openDialog('reprocess the payments')"
				id="btnReprocess"
			>
				<span>Reprocess Booking</span>
			</button>
		</ng-template>
	</div>

	<div class="button-container flex flex-align-stretch-end" *ngIf="buttonState === 'cancel'">
		<ng-template [appUserRolePermissions] [action]="'hide'" [roles]="['TS_IMPLEMENTATION_LEAD', 'TS_VO', 'CLIENT']">
			<div class="button-container flex flex-align-stretch-end">
				<button mat-raised-button class="process-button" (click)="cancelBookingClicked.emit()" id="btnCancel">
					<span>CANCEL BOOKING</span>
				</button>
			</div>
		</ng-template>
	</div>
	} @else {
	<div class="button-container flex flex-align-stretch-end">
		@if (bulkSelected.value !== "REPROCESS") {
		<ng-template
			[appUserRolePermissions]
			[action]="'hide'"
			[roles]="[
				'TS_IMPLEMENTATION_LEAD',
				'TS_IMPLEMENTATION_CONSULTANT',
				'TS_OPERATION_CONSULTANT',
				'TS_OCB',
				'TS_VO',
				'CLIENT'
			]"
		>
			<button
				mat-raised-button
				class="process-button"
				[disabled]="payoutIdList.length < 1"
				(click)="bulkActionButton(bulkSelected)"
				[attr.data-test]="'bulk-action-' + bulkSelected.value.toLowerCase()"
			>
				<span>{{ bulkSelected.buttonText }}</span>
			</button>
		</ng-template>
		} @else {
		<ng-template
			[appUserRolePermissions]
			[action]="'hide'"
			[roles]="[
				'TS_IMPLEMENTATION_LEAD',
				'TS_IMPLEMENTATION_CONSULTANT',
				'TS_OPERATION_CONSULTANT',
				'TS_OCB',
				'TS_VO',
				'CLIENT'
			]"
		>
			<button
				mat-raised-button
				class="process-button"
				[disabled]="payoutIdList.length < 1"
				(click)="openDialog('reprocess the payments')"
				[attr.data-test]="'bulk-action-' + bulkSelected.value.toLowerCase()"
			>
				<span>{{ bulkSelected.buttonText }}</span>
			</button>
		</ng-template>
		}
	</div>
	} @if(buttonState === 'completed') {
	<div [attr.data-test]="'payment-completed-label'" class="payments-completed-label">
		<app-icon [name]="'tick-circle'" [lineWidth]="'2px'" [color]="'var(--text-complete-color)'"></app-icon>
		<div class="body-semibold">PAYMENTS COMPLETED</div>
	</div>
	} @if(buttonState === 'complete-payments') {
	<div class="button-container flex flex-align-stretch-end">
		<ng-template [appUserRolePermissions] [action]="'hide'" [roles]="['TS_IMPLEMENTATION_LEAD', 'TS_VO', 'CLIENT']">
			<div class="button-container flex flex-align-stretch-end">
				<button
					mat-raised-button
					class="process-button"
					(click)="completePaymentsClicked.emit()"
					id="btnCompletePayments"
				>
					<span>COMPLETE PAYMENTS</span>
				</button>
			</div>
		</ng-template>
	</div>
	}
</div>
